import {Command} from '@application/command/command';
import {createProductionScheduleItemInPathGroupFromDrawing} from '@application/helper/production-schedule-builder/create-production-schedule-item-in-path-group-from-drawing';
import {updateProductionSchedulePathsOfColoredYarnSets} from '@application/helper/production-schedule-builder/update-production-schedule-paths-of-colored-yarn-sets';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {ListDrawingOrderLine} from '@presentation/components/drawing-list/list-drawing-order-line';
import {ParametersForAddingDrawingToProductionSchedulePath} from '@presentation/pages/texfab/production-schedule/add/plan/parameters-for-adding-drawing-to-production-schedule-path';
import {isNil} from 'lodash-es';

export class AddDrawingToProductionSchedulePathCommand implements Command<ParametersForAddingDrawingToProductionSchedulePath, ProductionSchedule> {
  public execute(actionArgs: ParametersForAddingDrawingToProductionSchedulePath): ProductionSchedule {
    const {productionSchedule, listDrawing, indexInProductionSchedulePath, productionSchedulePathNumber, startDentOfColoredYarnSet, uuidForProductionScheduleInPathGroup} = actionArgs;
    const productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet = productionSchedule.getProductionSchedulePathsOfColoredYarnSetAtStartDent(startDentOfColoredYarnSet);
    const productionSchedulePath: ProductionSchedulePath = productionSchedulePathsOfColoredYarnSet.getProductionSchedulePath(productionSchedulePathNumber);

    const productionScheduleItemInPathGroup = createProductionScheduleItemInPathGroupFromDrawing(
      listDrawing instanceof ListDrawingOrderLine ? null : productionSchedule.finishing,
      listDrawing,
      productionSchedule.machineQuality
    );
    if (!isNil(uuidForProductionScheduleInPathGroup)) {
      productionScheduleItemInPathGroup.adjustUuid(uuidForProductionScheduleInPathGroup);
    }

    if (isNil(indexInProductionSchedulePath)) {
      productionSchedulePath.pathGroups.push(productionScheduleItemInPathGroup);
    } else {
      productionSchedulePath.pathGroups.splice(indexInProductionSchedulePath, 0, productionScheduleItemInPathGroup);
    }

    return updateProductionSchedulePathsOfColoredYarnSets(productionSchedule);
  }
}
